module.exports = __webpack_public_path__ + "assets/img/96e2e63834a6f0fcebee656416c46081.png";